export const STEPS_ENUM = {
    INTERESTS_SELECTOR: 1,
    AGE_SELECTOR: 2,
}

export const INTERESTS_STEP_PARENT_TAGS = {
    LANGUAGES: 'languages',
    EXAMS: 'exams',
    MATHS: 'maths',
    SCIENCE: 'science',
    ARTS_AND_HUMANITIES: 'arts_and_humanities',
    SOCIAL_SCIENCES: 'social_sciences',
    MOVIES: 'movies',
    DRIVING_TEST: 'driving_test',
    COMPUTER_SKILLS: 'computer_skills',
    HOBBIES: 'hobbies',
    SPORT: 'sport',
    TRAVEL: 'travel',
    BEAUTY: 'beauty',
    OTHER: 'other',
}
export const INTERESTS_STEP_PARENT_TAGS_NAMES = Object.values(INTERESTS_STEP_PARENT_TAGS)

export const AGE_STEP_PARENT_TAGS_NAMES = ['age_4-6', 'age_7-9', 'age_10-12', 'age_13-17', 'age_18+']
